import { useEffect } from 'react';

import type { UseInventoryCardEffectsProps } from '@app/pages/Warehouses/Inventory/components/InventoryCard/types';

export const useInventoryCardEffects = ({
  fetchedHistoryHandler,
  scrollHistoryToBottom,
}: UseInventoryCardEffectsProps) => {
  useEffect(() => {
    fetchedHistoryHandler([]);
  }, [fetchedHistoryHandler]);

  useEffect(() => {
    scrollHistoryToBottom();
  }, [scrollHistoryToBottom]);
};
